var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiQIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#F6F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 38.6667L32.0002 32M32.0002 32L38.6668 38.6667M32.0002 32V47M45.3335 39.9047C47.3693 38.2234 48.6668 35.6799 48.6668 32.8333C48.6668 27.7707 44.5628 23.6667 39.5002 23.6667C39.136 23.6667 38.7953 23.4767 38.6104 23.1629C36.4369 19.4747 32.4242 17 27.8335 17C20.9299 17 15.3335 22.5964 15.3335 29.5C15.3335 32.9435 16.7259 36.0618 18.9784 38.3226",
    stroke: "url(#paint0_linear_446_15395)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_446_15395",
    x1: 15.3335,
    y1: 32,
    x2: 48.6779,
    y2: 32.2502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiQIcon);
export default __webpack_public_path__ + "static/media/MultiQIcon.2c42584c116752875daa92fda473a1fa.svg";
export { ForwardRef as ReactComponent };